<template>
    <div>
        <BaseModal 
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="$tc('userHeader.EmployeeProviderTitle', this.editMode ? 1 : 2)"
            :width="'50%'"
            :height="'auto'"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK },                   
            ]"              
            @Close="close"
        >
            <b-row>
                <b-col lg="9" md="9" sm="12">         
                    <MdSelect
                        v-bind:Label="$t('employee.Company')"
                        v-bind:Options="insuranceList"
                        v-bind:Model="editableItem.insuranceCode"
                        v-bind:FieldDescription="'description'"
                        v-bind:FieldCode="'code'"
                        v-bind:Multiple="false"       
                        :isRequired="true"      
                        :Input="changeDropDownInsurance"
                        :isValid="isValidCompany"
                        :IsDisabled="editMode"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit
                        v-model="editableItem.providerId"                    
                        v-bind:Label="$t('employee.ProviderId')"  
                        v-bind:isRequired="true"
                        v-bind:MaxLengthProp="15"
                        v-bind:Id="'input_e_pro'"
                        :isValid="isValidProvider"/>
                </b-col>
            </b-row>
        </BaseModal>
    </div>
</template>

<script>
import validationMixin from '@/common/validationMixin';
import validationRules from '@/common/validationRules';
import ShowMessage from '@/components/messages/ShowMessage.js';

export default {
    name: 'EmployeeProviderModal',
    mixins: [validationMixin, ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        insuranceList: {
            type: Array,
            required: true
        },
        editMode: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            modalId: 'EmployeeProviderModal',
            emitCloseEvent: false,
            editableItem: {...this.value},
            isValidProvider: true,
            isValidCompany: true
        }
    },

    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            }
        },
        value(newVal) {
            this.isValidProvider = true;
            this.isValidCompany = true;
            this.editableItem = {...newVal};
        }
    },

    methods: {
        emitEventCancel() {
            this.emitCloseEvent= false;
            this.$emit('update:visible', false);
        },

        emitEventOK(bvModalEvent) {
            if (this.validate()) {
                this.$emit('update:visible', false);
                this.$emit('ok', this.editableItem);
            } else {
                bvModalEvent.preventDefault();

                this.isValidProvider = this.isValid('providerId');
                this.isValidCompany = this.isValid('insuranceCode');
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent= false;
            }
        },

        close() {
            this.emitEventCancel();
        },

        validate() {
            const rules = {
                insuranceCode: [
                    validationRules.required(
                        this.$t("Msg.CheckRequiredFields")
                    ),
                ],
                providerId: [
                    validationRules.required(
                        this.$t("Msg.CheckRequiredFields")
                    ),
                ],
            }

            return this.validateFields(rules, this.editableItem);
        },

        changeDropDownInsurance(value) {
            this.editableItem.insuranceCode = value ? value.code : '';
            this.editableItem.companyName = value ? value.description : '';
        }
    }
}
</script>